export const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Register - Citizen Hub",
  description:
    "Create a new Citizen Hub account to access our immigration services and manage your account online.",
  mainEntity: {
    "@type": "LocalBusiness",
    name: "Citizen Hub",
    telephone: "+1 3108802133",
    email: "info@citizenhub.com",
  },
};
